export default angular
    .module('syModal', [])
    /**
     * @ngdoc service
     * @name syModal.service:ModalService2
     * @description
     * Creates a service to handle modal functions.
     */
    // @ngInject
    .service('ModalService2', [
        '$compile',
        '$rootScope',
        '$document',
        '$q',
        function ($compile, $rootScope, $document, $q) {
            var templateAlert =
                "<div class='modal2-overlay'>" +
                "<div class='modal2' ng-controller='modalController'>" +
                "<div class='modal2-header'>" +
                "<span class='icon icon--circle modal-icon' ng-if='modalIcon' sy-icon='{{modalIcon.name}}' colour='{{modalIcon.colour}}'></span>" +
                "<span class='modal2-title'>{{modalTitle}}</span>" +
                '</div>' +
                "<div class='modal2-content' ng-bind-html='modalContent'></div>" +
                "<div class='modal2-footer'>" +
                "<button type='button' class='modal2-button modal2-button--default' ng-click='closeModal(false);'>{{okButtonText}}</button>" +
                '</div>' +
                "<button type='button' class='icon icon--close' ng-click='closeModal(false);'><span>Close</span></button>" +
                '</div>' +
                '</div>'

            var templateConfirm =
                "<div class='modal2-overlay'>" +
                "<div class='modal2' ng-controller='modalController'>" +
                "<div class='modal2-header'>" +
                "<span class='icon icon--circle modal-icon' ng-if='modalIcon' sy-icon='{{modalIcon.name}}' colour='{{modalIcon.colour}}'></span>" +
                "<span class='modal2-title'>{{modalTitle}}</span>" +
                '</div>' +
                "<div class='modal2-content' ng-bind-html='modalContent'></div>" +
                "<div class='modal2-footer'>" +
                "<button type='button' class='modal2-button' ng-click='returnValue(false);'>{{noButtonText}}</button>" +
                "<button type='button' class='modal2-button modal2-button--default' ng-click='returnValue(true);'>{{yesButtonText}}</button>" +
                '</div>' +
                "<button type='button' class='icon icon--close' ng-click='closeModal(true);'><span>Close</span></button>" +
                '</div>' +
                '</div>'

            var templateForm =
                "<div class='modal2-overlay'>" +
                "<div class='modal2' ng-controller='modalController'>" +
                "<form name='modalForm' ng-submit='modalForm.$valid &amp;&amp; submitForm()' novalidate>" +
                "<div class='modal2-header'>" +
                "<span class='icon icon--circle modal-icon' ng-if='modalIcon' sy-icon='{{modalIcon.name}}' colour='{{modalIcon.colour}}'></span>" +
                "<span class='modal2-title' >{{modalTitle}}</span>" +
                '</div>' +
                "<div class='modal2-content'>" +
                "<div ng-bind-html='modalContent'></div>" +
                "<div ng-repeat-start='field in fields' ng-class=\"{'field-group--error': modalForm.{{field.name}}.$dirty &amp;&amp; modalForm.{{field.name}}.$invalid }\" ng-if='field.type !== \"radio\"'>" +
                "<div class='form-input-container'>" +
                "<label ng-attr-for=\"{{'modalForm-' + field.name}}\" class='form-label'>{{field.title}}</label>" +
                '<input ng-attr-type="{{field.type}}" ng-attr-id="{{\'modalForm-\' + field.name}}" ng-attr-name="{{field.name}}" ng-model="values[field.name]" class=\'form-input form-input--text\' ng-required="{{field.validation.required}}" />' +
                '</div>' +
                '<div ng-if=\'field.messages && field.messages.length > 0\' ng-messages="modalForm[field.name].$error" role="alert" class="form-group-error">' +
                "<div ng-repeat='item in field.messages' ng-message='{{item.key}}' class='form-error'><p>{{item.message}}</p></div>" +
                '</div>' +
                '</div>' +
                "<div ng-repeat-end ng-class=\"{'field-group--error': modalForm.{{field.name}}.$dirty &amp;&amp; modalForm.{{field.name}}.$invalid }\" class='field-group--radio' ng-if='field.type === \"radio\"'>" +
                "<span class='form-radio-heading'>{{field.title}}</span>" +
                "<div class='form-input-container form-input-container--radio'>" +
                "<input ng-repeat-start='value in field.values.split(\"|\")' type='radio' ng-attr-id=\"{{'modalForm-' + field.name + '-' + $index}}\" ng-attr-name=\"{{field.name}}\" ng-attr-value='{{value}}' ng-model=\"values[field.name]\" ng-required=\"{{field.validation.required}}\" class='form-input' />" +
                '<label ng-repeat-end ng-attr-for="{{\'modalForm-\' + field.name + \'-\' + $index}}" class="form-label"><span>{{value}}</span></label>' +
                '</div>' +
                '</div>' +
                '</div>' +
                "<div class='modal2-footer'>" +
                "<button type='button' class='modal2-button' ng-click='closeModal(true);' >{{cancelButtonText}}</button>" +
                "<button type='submit' class='modal2-button modal2-button--default' ng-disabled='!modalForm.$valid'>{{submitButtonText}}</button>" +
                '</div>' +
                "<button type='button' class='icon icon--close' ng-click='closeModal(true);' ><span>Close</span></button>" +
                '</form>' +
                '</div>' +
                '</div>'

            var self = this
            this.modalTemplates = []
            this.modalItem = null
            this.deferred = null

            var createModal = function (template) {
                if (self.modalItem) {
                    return
                }

                self.modalItem = angular.element(template)
                var body = $document.find('body')
                body.prepend($compile(self.modalItem)($rootScope))
            }

            var createPromise = function () {
                if (self.deferred) {
                    return
                }

                self.deferred = $q.defer()
            }

            var addContent = function (templateId, options) {
                if (!self.modalItem) {
                    return
                }

                var template = self.modalTemplates[templateId]

                // Retrieve the scope
                var scope = angular.element(self.modalItem.find('.modal2')).scope()

                // Clean up the template
                var html = template.template.html()
                if (options && options.replaceValues && options.replaceValues.length > 0) {
                    for (var f = 0; f < options.replaceValues.length; f++) {
                        var item = options.replaceValues[f]
                        if (item.src) {
                            html = html.replace(item.src, item.dest ? item.dest : '')
                        }
                    }
                }

                // Set the scope values
                scope.modalTitle = template.title
                scope.modalContent = html
                scope.modalIcon = template.icon
                scope.fields = options ? options.fields : null

                // Set the option values
                if (options) {
                    if (options.buttonText) {
                        if (options.buttonText.ok) {
                            scope.okButtonText = options.buttonText.ok
                        }
                        if (options.buttonText.no) {
                            scope.noButtonText = options.buttonText.no
                        }
                        if (options.buttonText.yes) {
                            scope.yesButtonText = options.buttonText.yes
                        }
                        if (options.buttonText.cancel) {
                            scope.cancelButtonText = options.buttonText.cancel
                        }
                        if (options.buttonText.submit) {
                            scope.submitButtonText = options.buttonText.submit
                        }
                    }
                }
            }

            var addErrorContent = function (errorMessage, title) {
                if (!self.modalItem) {
                    return
                }

                // Retrieve the scope
                var scope = angular.element(self.modalItem.find('.modal2')).scope()

                // Set the scope values
                scope.modalTitle = title
                scope.modalContent = errorMessage
                scope.modalIcon = {
                    name: 'cookie-alert',
                    colour: 'red-dark'
                }
            }

            var bindEvents = function () {
                if (!self.modalItem) {
                    return
                }

                self.modalItem.click(function (evt) {
                    if (evt.target !== this) {
                        return
                    }

                    evt.stopPropagation()
                    self.closeModal(true)
                })
            }

            // Open an alert modal for the error messages
            this.openErrorAlert = function (errorMessage, title) {
                // Only open modal if there is no existing modal
                if (self.modalItem) {
                    return
                }

                createModal(templateAlert)
                addErrorContent(errorMessage, title)
                bindEvents()
            }

            // Open an alert modal of the specified template id.
            this.openAlert = function (templateId, options) {
                // Only open modal if there is no existing modal or if the template exists
                if (self.modalItem || !self.modalTemplates[templateId]) {
                    return
                }
                createModal(templateAlert)
                addContent(templateId, options)
                bindEvents()
            }

            // Open an alert modal of the specified template id.
            this.openConfirm = function (templateId, options) {
                // Only open modal if there is no existing modal or if the template exists
                if (self.modalItem || !self.modalTemplates[templateId]) {
                    return null
                }

                createModal(templateConfirm)
                createPromise()
                addContent(templateId, options)
                bindEvents()

                return self.deferred ? self.deferred.promise : null
            }

            // Open an form modal of the specified template id.
            this.openForm = function (templateId, options) {
                // Only open modal if there is no existing modal or if the template exists
                if (self.modalItem || !self.modalTemplates[templateId]) {
                    return null
                }

                createModal(templateForm)
                createPromise()
                addContent(templateId, options)
                bindEvents()
                return self.deferred ? self.deferred.promise : null
            }

            // Close the current displayed modal.
            this.closeModal = function (throwError) {
                if (!self.modalItem) {
                    return
                }

                if (throwError && self.deferred) {
                    self.deferred.reject()
                }

                self.modalItem.remove()
                self.modalItem = null
                self.deferred = null
            }

            // Returns a value from the modal
            this.returnValue = function (value) {
                self.deferred.resolve(value)
                self.closeModal(false)
            }

            // Submit the form on the modal
            this.submitForm = function (value) {
                self.deferred.resolve(value)
                self.closeModal(false)
            }
        }
    ])
    /**
     * @ngdoc service
     * @name syModal.controller:modalController
     * @description
     * Creates a controller to handle modal functions.
     */
    // @ngInject
    .controller('modalController', [
        '$scope',
        'ModalService2',
        function ($scope, ModalService2) {
            // Default scope values
            $scope.modalTitle = null
            $scope.modalContent = null
            $scope.modalIcon = null
            $scope.okButtonText = 'OK'
            $scope.noButtonText = 'No'
            $scope.yesButtonText = 'Yes'
            $scope.cancelButtonText = 'Cancel'
            $scope.submitButtonText = 'Submit'
            $scope.values = {}

            // Close the modal
            $scope.closeModal = function (throwError) {
                ModalService2.closeModal(throwError)
            }

            // Return a value from the modal
            $scope.returnValue = function (value) {
                ModalService2.returnValue(value)
            }

            // Submit the form on the modal
            $scope.submitForm = function () {
                ModalService2.submitForm($scope.values)
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syModal.directive:syModal
     * @description
     * Adds the element to the list of modals in the service.
     */
    // @ngInject
    .directive('syModal', [
        'ModalService2',
        function (ModalService2) {
            return {
                restrict: 'A',
                link: function ($scope, $element, attrs) {
                    ModalService2.modalTemplates[attrs.syModal] = {
                        title: attrs.syModalTitle,
                        icon:
                            attrs.iconName && attrs.iconName !== ''
                                ? { name: attrs.iconName, colour: attrs.iconColour }
                                : undefined,
                        template: $element,
                        analyticsfailuremessage: attrs.syModalAnalyticsFailureMessage,
                        goalId: attrs.syModalGoalId
                    }
                    $element.remove()
                }
            }
        }
    ])
